module.exports = __webpack_public_path__ + "fonts/mc.b59ac9b.woff2";